import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { CDN_BASE } from "../api";
import type { Spread as SpreadModel } from "../bdl/model";
import { Chain } from "../components/Chain";

const PLAY = "https://play.google.com/store/apps/details?id=com.pessoatech.brainstorm_app";

/**
 * A shared chain: every beat with its figure moving, and the
 * two ways in — the app if it is installed, Google Play if not. What a
 * shared link lands on (philosophy/03 § Chrome).
 */
export function SpreadPage() {
  const { id = "" } = useParams();
  const [spread, setSpread] = useState<SpreadModel | null>();
  useEffect(() => {
    setSpread(undefined);
    if (!/^[a-z0-9-]{1,64}$/.test(id) || !CDN_BASE) { setSpread(null); return; }
    fetch(`${CDN_BASE}/spreads/${id}.json`).then((r) => (r.ok ? r.json() : null)).then((j) => setSpread(j as SpreadModel | null)).catch(() => setSpread(null));
  }, [id]);
  useEffect(() => { if (spread) document.title = `${spread.card.title} — BrainStorm`; }, [spread]);

  return (
    <div className="landing">
      <div className="hero">
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img src="/favicon.svg" alt="" width={28} height={28} />
            <Link to="/" className="head" style={{ textDecoration: "none" }}>BrainStorm</Link>
          </div>
          {spread === undefined && <p className="chrome" style={{ marginTop: 24 }}>Loading…</p>}
          {spread === null && (
            <>
              <h1 style={{ marginTop: 12 }}>Not here.</h1>
              <p className="lede">That piece isn't published, or the link is wrong.</p>
            </>
          )}
          {spread && (
            <>
              <h1 style={{ marginTop: 12 }}>{spread.card.title}</h1>
              <p className="hook" style={{ marginTop: 6 }}>{spread.card.hook}</p>
              <p className="lede">{spread.card.summary || spread.chain.beats[0]?.body}</p>
              <p style={{ marginTop: 20, display: "flex", gap: 12, flexWrap: "wrap" }}>
                <a className="button" href={`brainstorm://s/${id}`}>Open in the app</a>
                <a className="button quiet" href={PLAY}>Get it on Google Play</a>
              </p>
              <p className="chrome" style={{ marginTop: 12 }}>In the app, each step plays on the card, one at a time.</p>
            </>
          )}
        </div>
        <div style={{ justifySelf: "center" }}>{spread && <Chain spread={spread} />}</div>
      </div>
      <div className="foot chrome">© {new Date().getFullYear()} Pessoa-Tech · <Link to="/privacy">privacy</Link></div>
    </div>
  );
}
